export const ANALYTICS_KEY =
  process.env.REACT_APP_ANALYTICS_KEY || 'G-B2FTQNMZ6C';
